module.exports = __webpack_public_path__ + "static/media/PDF15.edf54b85.pdf";